"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const hooks_1 = require("common/hooks");
const react_1 = __importDefault(require("react"));
const components_1 = require("utils/components");
const classes = __importStar(require("./Card.module.scss"));
function Card({ title, tooltip, children, style, className, required, }) {
    const { formatMessage } = (0, hooks_1.useFormatter)();
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(classes["card"], className), style: style },
        title && (react_1.default.createElement("div", { className: classes["cardHeader"] },
            react_1.default.createElement("h3", { className: classes["cardTitle"] }, title),
            required && (react_1.default.createElement("span", { style: {
                    marginLeft: "4px",
                    verticalAlign: "middle",
                    padding: "1px 6px",
                    color: "#4E4C5A",
                    fontSize: "8px",
                    fontWeight: 700,
                    borderRadius: "6px",
                    whiteSpace: "nowrap",
                    backgroundColor: "#FACC15",
                } }, formatMessage("Field.Required"))),
            tooltip && (react_1.default.createElement(components_1.Button, { variant: "secondary", "data-tooltip-id": "tooltip", "data-tooltip-html": true && `<div class="tooltip-content">${tooltip}</div>`, style: {
                    borderRadius: "50%",
                    width: "16px",
                    height: "16px",
                    padding: "0",
                    flexShrink: 0,
                } },
                react_1.default.createElement("span", { className: "mdi mdi-information-variant size10" }))))),
        children));
}
exports.default = Card;
